import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../Auth/AuthContext'
import MigrantsProcessHistory from './components/process/MigrantsProcessHistory'
import MigrantsFooter from './components/MigrantsFooter'
import MigrantsHeader from './components/MigrantsHeader'
import { useHistory, useParams } from 'react-router-dom'
import { Key } from 'lucide-react'

const TAB_PROFILE = 'profile'
const TAB_HISTORY = 'history'

const tabLabels = {
  [TAB_PROFILE]: 'Datos de perfil',
  [TAB_HISTORY]: 'Historial de trámites',
}

const DashboardMigrantsUserInfo = () => {
  const { initialTab, id: _id, show } = useParams()
  const history = useHistory()

  const { dispatch, user } = useContext(AuthContext)
  const [reportId, setReportId] = useState(_id)
  const [view, setView] = useState(null)
  const [activeTab, setActiveTab] = useState(initialTab)

  useEffect(() => {
    // Set the initial active tab based on the prop
    setActiveTab(initialTab)
  }, [initialTab])

  useEffect(() => {
    if(view == 1) history.push('/dashboardMigrants/logged')
  },[view])

  // -------------- Functions --------------
  const handleTabChange = (tab) => {
    setActiveTab(tab)
    if (tab === TAB_PROFILE)
      setReportId(null) // Reset reportId when switching to profile tab
  }

  return (
    <div className="dashboard-migrants-user-info row">
      <div className="col-12">
        <MigrantsHeader user={user} dispatch={dispatch} />
      </div>
      <div className="col-12">
        <div className="migrant-user-info">
          <h5 className="title-migrates">Tu cuenta</h5>
          <div className="migrants-user-info-card">
            <div className="header">
              {Object.entries(tabLabels).map(([key, label]) => (
                <button
                  key={key}
                  onClick={() => handleTabChange(key)}
                  style={{
                    padding: '10px 20px',
                    border: 'none',
                    borderBottom:
                      activeTab === key ? '2px solid #FF6A00' : 'none',
                    background: 'none',
                    cursor: 'pointer',
                    fontWeight: activeTab === key ? 'bold' : 'normal',
                  }}
                >
                  <h6
                    className={`${
                      activeTab === key ? 'text-active' : 'text-inactive'
                    }`}
                  >
                    {label}
                  </h6>
                </button>
              ))}
            </div>
            <div className="content">
              {activeTab === TAB_PROFILE && (
                <div className="row profile-info">
                  <div className="col-12 col-md-6">
                    <h6>NOMBRE</h6>
                    <span>{user?.name || 'Sin datos'}</span>
                  </div>
                  <div className="col-12 col-md-6">
                    <h6>CORREO ELECTRÓNICO</h6>
                    <span>{user?.email || 'Sin datos'}</span>
                  </div>
                  <div className="col-12 col-md-6">
                    <h6>TELÉFONO</h6>
                    <span>{user?.phone || 'Sin datos'}</span>
                  </div>
                  <div className="col-12 col-md-6">
                    <h6>DIRECCIÓN</h6>
                    <span>{user?.address || 'Sin datos'}</span>
                  </div>
                  {/* <div className="col-12 col-md-6">
                <h6>CONTRASEÑA</h6>
                <span></span>
              </div> */}
                </div>
              )}
              {activeTab === TAB_HISTORY && (
                <MigrantsProcessHistory user={user} id={reportId} />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="col-12">
        <MigrantsFooter />
      </div>
    </div>
  )
}

export default DashboardMigrantsUserInfo
